import { CRMColors } from "../../../models/CRMColors";
import { THexColor } from "../../../models/StringLiterals";
import * as ListingStatus1 from "../../../../../domain/models/ListingStatus1";
import * as util from "../../../../../shared/src/util";

export type TListingStatusPillStyle = {
    pillColor: THexColor;
    borderColor: THexColor;
    textColor: THexColor;
};

export const listingStatusPillStyle = (status: ListingStatus1.T): TListingStatusPillStyle => {
    switch (status) {
        case "lead":
            return { pillColor: CRMColors.NEUTRAL_12, borderColor: CRMColors.NEUTRAL_8, textColor: CRMColors.NEUTRAL_0 };
        case "prep_valuation":
            return { pillColor: CRMColors.HIGHLIGHTS_CALMING_PINK_11, borderColor: CRMColors.HIGHLIGHTS_CALMING_PINK_6, textColor: CRMColors.HIGHLIGHTS_CALMING_PINK_0 };
        case "chase_instruction":
            return { pillColor: CRMColors.HIGHLIGHTS_PERTINENT_YELLOW_10, borderColor: CRMColors.HIGHLIGHTS_PERTINENT_YELLOW_4, textColor: CRMColors.NEUTRAL_0 };
        case "instructed_needs_market_prep":
            return { pillColor: CRMColors.HIGHLIGHTS_EASY_ORANGE_12, borderColor: CRMColors.HIGHLIGHTS_EASY_ORANGE_10, textColor: CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_0 };
        case "instructed_on_the_market":
            return { pillColor: CRMColors.PRIMARY_16, borderColor: CRMColors.PRIMARY_10, textColor: CRMColors.PRIMARY_2 };
        case "sstc":
            return { pillColor: CRMColors.HIGHLIGHTS_POSITIVE_GREEN_12, borderColor: CRMColors.HIGHLIGHTS_POSITIVE_GREEN_8, textColor: CRMColors.HIGHLIGHTS_POSITIVE_GREEN_0 };
        case "completed":
            return { pillColor: CRMColors.HIGHLIGHTS_POSITIVE_GREEN_0, borderColor: CRMColors.HIGHLIGHTS_POSITIVE_GREEN_0, textColor: CRMColors.NEUTRAL_PAPER };
        case "lost":
            return { pillColor: CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_12, borderColor: CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_6, textColor: CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_0 };
        case "auction":
            return { pillColor: CRMColors.HIGHLIGHTS_CALMING_PINK_10, borderColor: CRMColors.HIGHLIGHTS_CALMING_PINK_2, textColor: CRMColors.HIGHLIGHTS_CALMING_PINK_0 };
        default:
            return util.requireExhaustive(status);
    }
};

export const listingStatusShortLabel = (status: ListingStatus1.T): string => {
    switch (status) {
        case "lead":
            return "Lead";
        case "prep_valuation":
            return "Prep valuation";
        case "chase_instruction":
            return "Chase instruction";
        case "instructed_needs_market_prep":
            return "Needs market prep";
        case "instructed_on_the_market":
            return "On the market";
        case "sstc":
            return "SSTC";
        case "completed":
            return "Completed";
        case "lost":
            return "Lost";
        case "auction":
            return "At auction";
        default:
            return util.requireExhaustive(status);
    }
};
